export const splitDate = (date: string) => {
	const cleanDate = date.trim();

	const separators = ['/', '-', '.', ' '];
	let separator = '';

	for (const sep of separators) {
		if (cleanDate.includes(sep)) {
			separator = sep;
			break;
		}
	}

	if (!separator) {
		throw new Error(
			'Неподдерживаемый формат даты. Используйте DD/MM/YYYY, DD-MM-YYYY, DD.MM.YYYY, YYYY-MM-DD или другие стандартные форматы'
		);
	}

	const parts = cleanDate.split(separator).map((part) => part.trim());

	if (parts.length === 3) {
		const [part1, part2, part3] = parts;
		const num1 = Number.parseInt(part1, 10);
		const num2 = Number.parseInt(part2, 10);
		const num3 = Number.parseInt(part3, 10);

		if (num1 > 31 && num2 <= 12 && num3 <= 31) {
			return `${num1}-${String(num2).padStart(2, '0')}-${String(num3).padStart(2, '0')}`;
		}

		if (num1 <= 31 && num2 <= 12 && num3 > 31) {
			return `${num3}-${String(num2).padStart(2, '0')}-${String(num1).padStart(2, '0')}`;
		}

		if (num1 <= 12 && num2 <= 31 && num3 > 31) {
			return `${num3}-${String(num1).padStart(2, '0')}-${String(num2).padStart(2, '0')}`;
		}
	}

	throw new Error(
		'Неподдерживаемый формат даты. Используйте DD/MM/YYYY, DD-MM-YYYY, DD.MM.YYYY, YYYY-MM-DD или другие стандартные форматы'
	);
};

export const newDateFormat = (date: string) => {
	const formattedToNewDate = new Date(splitDate(date));
	return formattedToNewDate;
};

export const dateToRFC = (date: Date) => {
	const dateTimezoneCorrection = new Date(
		 
		date.getTime() - date.getTimezoneOffset() * 60000
	);
	const toRFC = `${dateTimezoneCorrection.toISOString().split('.')[0]}Z`;
	return toRFC;
};
